<template>
  <v-layout column>
    <WarehousesTable
      :items="warehouses"
      :amount="warehousesAmount"
      :is-loading="isLoading"
    />
    <BasePagination
      :per-page="perPage"
      :amount-all="warehousesAmount"
      :pagination="pagination"
      @page="setPage($event)"
      @amount="setItemsPerPage($event)"
    />
  </v-layout>
</template>

<script>
import WarehousesTable from '@/components/warehouse/warehousesList/WarehousesTable';
import BasePagination from '@/components/widgets/dataTable/BasePagination';

export default {
    name: 'WarehousesList',
    components: { WarehousesTable, BasePagination },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            perPage: [{ amount: 20 }, { amount: 50 }],
            filtersParams: null
        };
    },
    computed: {
        warehouses () {
            return this.$store.getters['warehouses/getAvailableWarehouses'];
        },
        warehousesAmount () {
            return this.$store.getters['warehouses/getAvailableWarehousesAmount'];
        },
        pagination () {
            return this.$store.getters['warehouses/getPagination'];
        }
    },
    watch: {
        warehousesAmount: {
            handler (val) {
                this.pagination.amountAll = val;
            },
            immediate: true
        }
    },
    methods: {
        setPage (event) {
            this.$store.commit('warehouses/setPagination', { page: event });
            this.$emit('pagination');
        },
        setItemsPerPage (event) {
            this.$store.commit('warehouses/setPagination', { page: 1, amount: event });
            this.$emit('pagination');
        }
    }
};
</script>

<style scoped></style>
